import { ReduceStore } from 'flux/utils';
import { OrderedMap, Record } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

export const SavedJob = Record({
  id: null,
  name: null,
  organizationId: null,
  config: null,
  scheduleId: null,
  runAsUserEmail: null,
  scheduleCron: null,
}, 'SavedJob');

const composeSavedJob = (savedJob, schedule = undefined) => (
  new SavedJob({
    id: savedJob.id,
    name: savedJob.name,
    organizationId: savedJob.organizationId,
    config: savedJob.config,
    scheduleId: schedule.id,
    runAsUserEmail: schedule.userEmail,
    scheduleCron: schedule.cronExpression,
  })
);

class SavedJobsStore extends ReduceStore {
  getInitialState() {
    return new OrderedMap();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.SavedJobs.RECEIVE_SAVED_JOBS:
        return new OrderedMap(action.savedJobs.map(
          job => [job.id, new SavedJob(job)]));
      case Constants.SavedJobs.JOB_RECEIVED:
        return state.set(
            action.savedJob.id,
            composeSavedJob(action.savedJob, action.schedule),
          );
      case Constants.SavedJobs.JOB_UPDATED:
        return state.set(action.savedJob.id, new SavedJob(action.savedJob));
      case Constants.SavedJobs.JOB_DELETED:
        return state.delete(action.savedJobId);
      default:
        return state;
    }
  }

  get(id, defaultValue = null) {
    return this.getState().get(id, defaultValue);
  }

  getForFilter() {
    return this.getState();
  }
}

const instance = new SavedJobsStore(AppDispatcher);
export default instance;
